// I filtri per tag sono link server-side; questa aggiunta conserva prezzo, ordine e anteprima.
function preserveRefinementQuery(links=document.querySelectorAll('[data-kg-refinement-link]')){
  const current=new URL(location.href);
  for(const link of links){
    const target=new URL(link.getAttribute('href'),location.origin);
    for(const key of new Set(current.searchParams.keys()))target.searchParams.delete(key);
    target.searchParams.delete('page');
    for(const [key,value] of current.searchParams)if(key!=='page')target.searchParams.append(key,value);
    link.href=target.pathname+target.search;
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>preserveRefinementQuery(),{once:true});else preserveRefinementQuery();
document.addEventListener('shopify:section:load',()=>preserveRefinementQuery());
// Anche dopo un aggiornamento AJAX di Horizon o del prezzo, si usa la query corrente.
for(const type of ['click','auxclick','focusin'])document.addEventListener(type,event=>{
 const link=event.target.closest?.('[data-kg-refinement-link]');if(link)preserveRefinementQuery([link]);
},true);
